var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000006108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 132,
    viewBox: "0 0 122 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2124632606992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8 34.1016V3.60156L3 34.1016H28.8Z",
    fill: "#BC92C2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M105.8 132V117.4C105.2 117.8 104.5 118.2 103.9 118.5V130.1H1.9V36H30.7V1.9H103.8V63C104.5 63.3 105.1 63.7 105.7 64.1V0H29.3L0 34.8V132H105.8ZM3 34.1L28.8 3.6V34.1H3Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 43.8984H72.7C73.2 43.8984 73.7 44.2984 73.7 44.8984C73.7 45.3984 73.3 45.8984 72.7 45.8984H18C17.5 45.8984 17 45.4984 17 44.8984C17 44.3984 17.5 43.8984 18 43.8984Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18 55.3984H64C64.5 55.3984 65 55.7984 65 56.3984C65 56.8984 64.6 57.3984 64 57.3984H18C17.5 57.3984 17 56.9984 17 56.3984C17 55.7984 17.5 55.3984 18 55.3984Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18 66.8008H34.4C34.9 66.8008 35.4 67.2008 35.4 67.8008C35.4 68.3008 35 68.8008 34.4 68.8008H18C17.5 68.8008 17 68.4008 17 67.8008C17 67.2008 17.5 66.8008 18 66.8008Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18 78.1992H51.9C52.4 78.1992 52.9 78.5992 52.9 79.1992C52.9 79.6992 52.5 80.1992 51.9 80.1992H18C17.5 80.1992 17 79.7992 17 79.1992C17 78.6992 17.5 78.1992 18 78.1992Z",
    fill: "#3E004A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M89.1998 58.3984C98.0998 58.3984 106.2 61.9984 112.1 67.8984C118 73.7984 121.6 81.8984 121.6 90.7984C121.6 99.6984 118 107.798 112.1 113.698C106.2 119.598 98.0998 123.198 89.1998 123.198C80.2998 123.198 72.1998 119.598 66.2998 113.698C60.3998 107.798 56.7998 99.6984 56.7998 90.7984C56.7998 81.8984 60.3998 73.7984 66.2998 67.8984C72.1998 61.9984 80.2998 58.3984 89.1998 58.3984ZM110.7 69.2984C105.2 63.7984 97.5998 60.3984 89.1998 60.3984C80.7998 60.3984 73.1998 63.7984 67.6998 69.2984C62.1998 74.7984 58.7998 82.3984 58.7998 90.7984C58.7998 99.1984 62.1998 106.798 67.6998 112.298C73.1998 117.798 80.7998 121.198 89.1998 121.198C97.5998 121.198 105.2 117.798 110.7 112.298C116.2 106.798 119.6 99.1984 119.6 90.7984C119.6 82.3984 116.2 74.7984 110.7 69.2984Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M85.2998 105.1C85.2998 107.3 87.0998 109.1 89.2998 109.1C91.4998 109.1 93.2998 107.3 93.2998 105.1C93.2998 102.9 91.4998 101.1 89.2998 101.1C86.9998 101.1 85.2998 102.9 85.2998 105.1ZM91.0998 105.1C91.0998 106.1 90.2998 107 89.1998 107C88.1998 107 87.2998 106.2 87.2998 105.1C87.2998 104.1 88.0998 103.2 89.1998 103.2C90.2998 103.2 91.0998 104 91.0998 105.1ZM89.1998 72.5C88.5998 72.5 88.1998 73 88.1998 73.5V94.5C88.1998 95.1 88.6998 95.5 89.1998 95.5C89.6998 95.5 90.1998 95 90.1998 94.5V73.5C90.2998 72.9 89.7998 72.5 89.1998 72.5Z",
    fill: "#3E004A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000006108);
export default __webpack_public_path__ + "static/media/Group 1000006108.e11ffc034ecc0fe9d86757886c151bb5.svg";
export { ForwardRef as ReactComponent };